import React, { Fragment, ReactElement } from 'react';

import { Underline } from '../../shared/underline/Underline';

import styles from './LinkList.styles.css';
import { IShopifySectionLink } from './shopifyFooterSections';

interface ILinkListProps {
    links: IShopifySectionLink[];
}

export function LinkList (props: ILinkListProps): ReactElement {
    const { links }: ILinkListProps = props;

    return (
        <Fragment>
            {links.map((link: IShopifySectionLink): ReactElement => {
                const { title, url }: IShopifySectionLink = link;

                return (
                    <li key={`${title}-${url}`} className={`text-med font-regular mb-2 h-3 ${styles.li}`}>
                        <Underline>
                            <a className="text-white" href={url}>
                                {title}
                            </a>
                        </Underline>
                    </li>
                );
            })}
        </Fragment>
    );
}
